<template>
<div class="columns is-multiline">
    <div class="column is-12">
        <div class="field">
            <input v-model="name" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Account name" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="!hasError('name')" class="help">An intuitive name to recognize the account later.</span>
            <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input v-model="key" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('aws_lightsail_key') }" class="input custom-input-size is-medium" placeholder="Key Id" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="hasError('aws_lightsail_key')" class="help is-danger">{{ getError('aws_lightsail_key') }}</span>
            <span v-if="!hasError('aws_lightsail_key')" class="help">Your AWS Access Key ID.</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input v-model="secret" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('aws_lightsail_secret') }" class="input custom-input-size is-medium" placeholder="Key Secret" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="hasError('aws_lightsail_secret')" class="help is-danger">{{ getError('aws_lightsail_secret') }}</span>
            <span v-if="!hasError('aws_lightsail_secret')" class="help">Your AWS Access Key Secret.</span>
        </div>
    </div>
    <div class="column is-12" style="margin-bottom: 10px;">
        <div class="field">
            <div class="control has-icons-left">
                <div class="select is-fullwidth">
                    <select v-model="regionKey" :disabled="creatingAccount" name="aws-region">
                        <option v-for="region in regions" :value="region.key" v-bind:key="region.key">{{ region.name }}</option>
                    </select>
                </div>
                <div class="icon is-left is-custom-icon-left">
                    <font-awesome-icon icon="globe-americas"/>
                </div>
            </div>
        </div>
        <span class="help" style="display: inline-block; margin-top: 6px;">The region where the Lightsail instances are located.</span>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            name: '',
            key: '',
            secret: '',
            regionKey: 'us-east-2',
            allowedInputs: ['name', 'aws_lightsail_key', 'aws_lightsail_secret', 'aws_lightsail_region'],
            error: '',
            creatingAccount: false,
            regions: [
                {
                    key: 'us-east-2',
                    name: 'US East (Ohio)'
                },
                {
                    key: 'us-east-1',
                    name: 'US East (N. Virginia)',

                },
                {
                    key: 'us-west-1',
                    name: 'US West (N. California)',
                },
                {
                    key: 'us-west-2',
                    name:'US West (Oregon)',
                },
                {
                    key: 'eu-central-1', 
                    name: 'Europe (Frankfurt)',
                },
                {
                    key: 'eu-west-1',
                    name: 'Europe (Ireland)',
                },
                {
                    key: 'eu-west-2',
                    name: 'Europe (London)',
                },
                {
                    key: 'eu-south-1',
                    name: 'Europe (Milan)',
                },
                {
                    key: 'eu-west-3',
                    name: 'Europe (Paris)',
                },
                {
                    key: 'eu-north-1',
                    name: 'Europe (Stockholm)',
                },
                {
                    key: 'af-south-1',
                    name: 'Africa (Cape Town)',
                },
                {
                    key: 'ap-east-1',
                    name: 'Asia Pacific (Hong Kong)',
                },
                {
                    key: 'ap-south-1',
                    name: 'Asia Pacific (Mumbai)',
                },
                {
                    key: 'ap-northeast-3',
                    name: 'Asia Pacific (Osaka-Local)',
                },
                {
                    key: 'ap-northeast-2',
                    name: 'Asia Pacific (Seoul)',
                },
                {
                    key: 'ap-southeast-1',
                    name: 'Asia Pacific (Singapore)',
                },
                {
                    key: 'ap-southeast-2',
                    name: 'Asia Pacific (Sydney)',
                },
                {
                    key: 'ap-northeast-1',
                    name: 'Asia Pacific (Tokyo)',
                },
                {
                    key: 'ca-central-1',
                    name: 'Canada (Central)',
                },
                {
                    key: 'cn-north-1',
                    name: 'China (Beijing)',
                },
                {
                    key: 'cn-northwest-1',
                    name: 'China (Ningxia)',
                },
                {
                    key: 'sa-east-1',
                    name: 'South America (São Paulo)',
                },
                {
                    key: 'me-south-1',
                    name: 'Middle East (Bahrain)',
                },
            ],
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        createAccount() {
            if (this.creatingAccount) {
                return;
            }

            this.creatingAccount = true;
            this.resetErrors();

            Api().post('accounts', this.newAccountData)
                .then(response => {
                    Event.$emit('refreshAccounts', () => {
                        Event.$emit('closeAddAccount');
                        swal('Success!', 'The AWS Lightsail account was connected.', 'success');
                    });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.creatingAccount = false;
                });
        },

        listenEvents() {
            let vm = this;

            Event.$on('createProviderAccount', (providerSlug) => {
                if (providerSlug == 'aws_lightsail') {
                    vm.createAccount();
                }
            });

            Event.$on('addAccountClosed', () => {
                this.resetErrors();
                this.name = '';
                this.key = '';
                this.secret = '';
                this.regionKey = 'us-east-2';
                this.error = '';
            });
        },
    },

    computed: {
        newAccountData() {
            return {
                provider_slug: 'aws_lightsail',
                name: this.name,
                aws_lightsail_key: this.key,
                aws_lightsail_secret: this.secret,
                aws_lightsail_region: this.regionKey,
            }
        },
    },

    watch: {
        creatingAccount(creatingAccount) {
            Event.$emit('creatingAccountLoaderUpdated', creatingAccount);
        },
    },
}
</script>
